import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {LinkSubjectToTeamContainerModel} from '../../../../../models/aggregates/team';


@Injectable({
  providedIn: 'root'
})
export class LinkSubjectToTeamService extends BaseApiTemplateService<LinkSubjectToTeamContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'users-team';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'users-team';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'users-team';
    this.httpClient = http;
  }
}
